<template>
    <div>
        <v-stepper v-model="e1">
            <v-stepper-header class="">
                <!-- no-box-shadow -->
                <template v-for="item of wizarData">
                    <v-stepper-step @click="triggerStep(item)" :rules="!item.validar ? [() => false] : [() => true]"
                        color="yellow darken-3" :key="`${item.num}-step`" :complete="e1 > item.num" :step="item.num"
                        editable>
                        {{ item.name }}
                        <small class="pt-1">{{ !item.validar ? item.validarText : "" }}</small>
                    </v-stepper-step>
                    <v-divider class="dividerwizzard" v-if="item.num != wizarData.length" :key="item.num"></v-divider>
                </template>

            </v-stepper-header>
            <v-stepper-items>
                <v-stepper-content v-for="item of wizarData" :key="`${item.num}-content`" :step="item.num"
                    :class="item.class">
                    <component :is="item.component" :estadoComp="estadoWizard" :estadoValidacion="wizardValidacion"
                        :wizardChange="cambiarPaso" :parametros="parametros" @wizardNext="nextOrbackStep"
                        @validate="validarDatos" @close="cerrarModal" @hide-modal="$emit('hide-modal')">
                    </component>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>

    </div>

</template>

<script>
// import axios from '@/helpers/axios'
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'
import InformacionComp from './evaluacionInformacion.vue'
import PreguntasComp from './evaluacionPreguntas.vue'
import CompetenciasComp from './evaluacionCompetencias.vue'
import AlumnosComp from './evaluacionAlumnos.vue'
import ComunDialogComp from '../../../../../components/ComponentsEst/ComunDialogComp.vue'
export default {
    name: "wizardEvaluacion",
    props: {
        parametros: {
            type: Object
        },
        estadoWizard: {
            type: Boolean
        },
    },
    components: {
        InformacionComp,
        PreguntasComp,
        CompetenciasComp,
        ComunDialogComp,
        AlumnosComp
    },
    data: () => ({
        paramComponente: { "id_modulo": 8, 'id_submodulo': 96 },
        datoLogin: sessionStorage,
        titulo: "Programar evaluación",
        wizardParametro: {},
        wizardEstado: false,
        wizardValidacion: false,
        progData: [],
        e1: 1,
        cambiarPaso: null
    }),
    computed: {
        ...mapGetters({
            componenteEvento: 'login/componenteEvento', // this.actualizarParamentro()
        }),
        ...mapState({
            wizarData: state => state.gestEvaluacion.wizarData,
        }),
    },
    watch: {
        e1(newStep, oldStep) {
           
            this.cambiarPaso = oldStep;
        },
        estadoWizard(flag) {
            this.e1 = 1
            if (flag) {
                this.loadMain();
            } else {
                this.limpiarWizarData();
            }
        },
    },
    mounted() {
        this.loadMain();
    },
    methods: {
        ...mapMutations({
            setEnviarMens: "mensajeSis/setEnviarMens",
            limpiarWizarData: "gestEvaluacion/limpiarWizarData"
        }),
        ...mapActions({
            parametroComponente: "login/parametroComponente",
            validateForm: "gestEvaluacion/validateForm",
        }),
        actualizarParamentro() {
            this.parametroComponente(this.paramComponente)
        },
        /** 
         _________________________
        |  MÉTODO CARGA INICIAL */
        loadMain() {
            this.e1 = 1
        },
        /** 
         __________________________________
        |  MÉTODO DETECTA CAMBIO STEPER  */
        // eslint-disable-next-line no-unused-vars
        triggerStep(item) {
            this.wizardValidacion = false;
        },
        /** 
         ___________________________
        |  MÉTODO SIGUIENTE PASO  */
        nextOrbackStep(n) {
            if (n == -1) { //RETROCEDE UN COMP ANTERIOR
                this.$emit('anterior', this.parametros.items.id_programacion);
                // this.wizardEstado = false;
            }

            if (n == this.wizarData.length) {
                this.e1 = 1
            } else {
                this.e1 = n + 1;
                this.$emit('hide-modal');
            }
        },
        /** 
         _____________________________
        |  MÉTODO CERRAR COMPONENTE */
        cerrarModal() {
            this.loadMain();
            this.$emit('anterior', this.parametros.items.id_programacion);
            this.$emit('close')
        },
        /** 
         ___________________________________
        |  MÉTODO VALIDAR FORM COMPONENTE */
        validarDatos(flag) {
            this.wizardValidacion = flag;
        },
    }
};
</script>
<style>
.v-stepper__header.no-box-shadow {
    box-shadow: none;
}

.dividerwizzard {
    border-width: thin 0 2px;
}
</style>